import axios from 'axios';

export const updateRequestContract = async (body) => {
    const url = `/api/v1/user_profile/request_contract`;
    const config = body instanceof FormData ? {headers: { "Content-Type": "multipart/form-data" }} : {}
    const res = await axios.patch(url, body, config);
    return res.data;
}

export const getSmtpOptions = async () => {
    const url = `/api/v1/user_profile/request_contract/smtp_options`;
    const res = await axios.get(url);
    return res.data;
}